import styled from '@emotion/styled/macro';
import theme from 'ui/theme/theme';
import { Tab, TabList } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Checkbox, Input, keyframes } from '@chakra-ui/react';

export const StyledTab = styled(Tab)`
  border-left: none;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  padding: 8px 0px;
`;

// export const StyledTabList = styled(TabList)`
//   flex: 1;
//   border: none;
//   border-radius: 8px;
//   padding-top: 16px;
//   padding-left: 16px;
//   padding-bottom: 24px;
//   margin-top: 12px;
//   background: ${theme.colors.gray['50']};
// `;

export const StyledIconTab = styled(Tab)`
  border-left: none;
  justify-content: flex-start;
  text-align: left;
  padding: ${(props) => (props.icon ? `10px 20px` : '6px 20px')};
  width: 100%;
  margin: 0px;
`;

// TODO: hover color will change in the future, wait for update
export const LinkTab = styled(Link)`
  background-color: ${(props) =>
    props.selected ? `${theme.colors.gray['200']}` : 'unset'};
  border-left: ${(props) =>
    props.selected && props.icon ? '3px solid #4CAF50' : 'none'};
  width: 100%;
  &:hover {
    background: ${theme.colors.gray['200']};
  }
`;

export const ToolsSideNav = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 210px;
`;

export const ToolsSideDivider = styled.div`
  margin: 30px 0px;
  width: 35px;
  height: 2px;
  backgroud: ${theme.colors.gray['200']};
`;

export const ContentContainer = styled.div`
  width: 100%;
  min-width: 400px;
  padding-left: 20px;
  margin-top: 30px;

  @media (min-width: ${theme.breakpoints.lg}) {
    padding-left: 40px;
    margin-top: 0px;
  }
`;

export const Wrapper = styled.div`
  min-width: 210px;
  padding: ${(props) => (props.padding ? `${props.padding}` : '8px 0px')};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}` : '16px')};
  margin-right: 20px;
  background: ${theme.colors.gray['50']};
  border-radius: 8px;
  display: none;

  @media screen and (min-width: ${theme.breakpoints.lg}) {
    display: block;
  }
`;

export const StyledTabList = styled(TabList)`
  border: none;
`;

export const $Checkbox = styled(Checkbox)`
  .chakra-checkbox__label {
    width: 100%;
  }
  margin-top: 2px;
  border-color: ${theme.colors.semantics.default};

  .chakra-checkbox__control[data-checked] {
    background: ${theme.colors.semantics.default};
    color: ${theme.colors.gray['0']};
  }

  .chakra-checkbox__control[data-disabled] {
    background: ${theme.colors.gray['0']};
    color: ${theme.colors.gray['0']};
    border-color: ${theme.colors.semantics.disabled};
  }
`;

export const StyledInput = styled(Input)`
  &.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const pulseRing = keyframes`
0% {
  transform: scale(0.33);
}
40%,
50% {
  opacity: 0;
}
100% {
  opacity: 0;
}
`;
